import axios from 'api';

export const getLobData = ({ search, pageSize, pageIndex }) => {
  return axios.get(`api/lob/lob/?search=${search}&page=${pageIndex}&page_size=${pageSize}`);
};

export const updateLob = (params) => {
  return axios.put(`api/lob/lob/${params.id}/`, params);
};

export const createLob = (params) => {
  return axios.post(`api/lob/lob/`, params);
};

export const deleteLob = (id) => {
  return axios.delete(`api/lob/lob/${id}`);
};

export const getTeamsData = ({ search, pageSize, pageIndex }) => {
  return axios.get(`api/team/team/?search=${search}&page=${pageIndex}&page_size=${pageSize}`);
};

export const updateTeam = (params) => {
  return axios.put(`api/team/team/${params.id}/`, params);
};

export const createTeam = (params) => {
  return axios.post(`api/team/team/`, params);
};

export const deleteTeam = (id) => {
  return axios.delete(`api/team/team/${id}`);
};

export const getUsersData = ({ search, pageSize, pageIndex }) => {
  return axios.get(`api/account/usermanage/?search=${search}&page=${pageIndex}&page_size=${pageSize}`);
};

export const updateUser = (params) => {
  return axios.patch(`api/account/usermanage/${params.id}/`, params);
};

export const updateUserProfilePic = (params) => {
  return axios.put(
    `api/account/usermanage/${params.id}/manage_profile_picture/`,
    { profile_picture: params.profilePicture },
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  );
};

export const createUser = (params) => {
  return axios.post(`api/account/usermanage/`, params);
};

export const deleteUser = (id) => {
  return axios.delete(`api/account/usermanage/${id}`);
};

export const getAllLobs = () => {
  return axios.get(`api/lob/lob/?get_all=true`);
};

export const getAllTeams = () => {
  return axios.get(`api/team/team/?get_all=true`);
};

export const resetPassword = (params) => {
  return axios.post(`api/account/usermanage/reset_password/?user_id=${params.id}`, params);
};

export const createUserVoiceSignature = (params) => {
  return axios.post(`api/account/uservoicesignature/`, params, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const deleteUserVoiceSignature = (id) => {
  return axios.delete(`api/account/uservoicesignature/${id}/`);
};

export const getUserVoiceSignature = (id) => {
  return axios.get(`api/account/uservoicesignature/?user_id=${id}`);
};
